import React, { FC } from 'react';

import {
	DELETED_SESSION_POPUP_TEXT,
	DELETED_SESSION_POPUP_TITLE,
	DELETED_SESSION_STATE_KEY
} from 'src/apps/wfa/helpers/WfaDashboardConsts';
import { ReportNotFoundPopup } from 'src/common/components/report-not-found-popup/ReportNotFoundPopup';

export const WfaSessionDeletedPopup: FC = () => {
	return (
		<ReportNotFoundPopup
			title={DELETED_SESSION_POPUP_TITLE}
			text={DELETED_SESSION_POPUP_TEXT}
			stateKey={DELETED_SESSION_STATE_KEY}
			isCentered
		/>
	);
};
